import { createSlice } from "@reduxjs/toolkit";
import { MyGarageSteps } from "../../utils/constants/myGarage";

const initialState = {
  activeStep: MyGarageSteps[0],
  vehicle_id: null,
  selectedVehicle: null,
  forms: {
    generalInfo: null,
    questionare: null,
    specifications: null,
    gallery: null,
  },
  previouslySubmittedForms: {
    generalInfo: null,
    questionare: null,
    specifications: null,
    gallery: null,
  },
  isEditing: false,
  areEditFormsSet: false
};

const myGarageSlice = createSlice({
  name: "myGarage",
  initialState,
  reducers: {
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload || false;
    },
    setAreEditFormsSet: (state, action) => {
      state.areEditFormsSet = action.payload || false;
    },
    goBackCarSellStep: (state) => {
      state.activeStep = MyGarageSteps.indexOf(state.activeStep) > 0 ? 
        MyGarageSteps[MyGarageSteps.indexOf(state.activeStep) - 1] :
        0;
    },
    setVehicleId: (state, action) => {
      state.vehicle_id = action?.payload?.vehicle_id;
    },
    setSelectedVehicle: (state, action) => {
      state.selectedVehicle = action?.payload?.selectedVehicle || null;
    },
    setGeneralInfoForm: (state, action) => {
      state.forms.generalInfo = action.payload;
    },
    setQuestionareForm: (state, action) => {
      state.forms.questionare = action.payload;
    },
    setSpecificationsForm: (state, action) => {
      state.forms.specifications = action.payload;
    },
    setGalleryForm: (state, action) => {
      state.forms.gallery = action.payload;
    },
    setMyGarageMultipleFields: (state, action) => {
      for (let i = 0; i < Object.entries(action?.payload)?.length; i++) {
        state[Object.entries(action?.payload)?.[i]?.[0]] = Object.entries(action?.payload)?.[i]?.[1];
      }
    },
    resetMyGarageSlice: (state, action) => {
      return initialState;
    }
  },
});

export const {
  setIsEditing,
  setAreEditFormsSet,
  setSelectedVehicle,
  setMyGarageMultipleFields,
  setActiveStep,
  setGeneralInfoForm,
  setQuestionareForm, 
  setSpecificationsForm, 
  setGalleryForm,
  goBackCarSellStep,
  setVehicleId,
  resetMyGarageSlice
} = myGarageSlice.actions;

export default myGarageSlice.reducer;
